import React from 'react';
import ClassNames from 'classnames';

export default function (Component) {
  const ValidationMixin = React.createClass({
    propTypes:{
      className: React.PropTypes.string,
      isNotValid: React.PropTypes.bool
    },
    getClass(){
      return ClassNames({notValid: this.props.isNotValid}, this.props.className)
    },
    render() {
      return <Component {...this.props} {...this.state} className={this.getClass()} />;
    }
  });
  return ValidationMixin;
};



/** WEBPACK FOOTER **
 ** ./src/validations/validation-mixin/index.js
 **/